module.exports = __webpack_public_path__ + "static/media/burger-king.4d735ee5.svg";